import axios from "axios";

const BASE_URL = process.env.REACT_APP_SERVER;

const endpoints = {
  default: "/api/v1/logs",
  get: "/get",
};

export function getLogs({ page, limit, apiKey }) {
  let requestUrl =
    BASE_URL + endpoints.default + endpoints.get + `?limit=${limit}`;

  if (page) {
    requestUrl += `&skip=${(page - 1) * limit}`;
  }

  console.log("requestUrl", requestUrl);

  var config = {
    method: "get",
    url: requestUrl,
    headers: {
      "x-api-key": apiKey,
    },
  };

  return axios(config);
}
